export enum ButtonStyle {
  Primary = 'primary',
  Secondary = 'secondary',
  Warning = 'warning',
  Link = 'link',
  NoLink = 'no-link'
}
